import axios from "axios";

const API_URL = `https://paymeapi.ligglo.co.ke/PayMeJWT/`;

//const API_URL = `https://localhost:44321/PayMeJWT/`;

const getAllClients = () => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.get(API_URL + "readclients", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getClient = (clientId) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.get(API_URL + `readclient/${clientId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getUsers = () => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  console.log(user);
  console.log(token);
  return axios.get(API_URL + "readusers", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const createClient = (accountId, clientName, phoneNumber, userId) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "createpaymeclient",
    {
      accountId,
      clientName,
      phoneNumber,
      userId,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const retryTransactions = (transactionIds) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(API_URL + "retrytransactions", [...transactionIds], {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const updateFloat = (
  clientNumber,
  amount,
  phoneNumber,
  customerName,
  description
) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "updatefloat",
    {
      clientNumber,
      amount,
      phoneNumber,
      customerName,
      description,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const linkUser = (clientId, userId) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "linkuser",
    { clientId, userId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const delinkUser = (clientId, userId) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "delinkUser",
    { clientId, userId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const processTransactions = (transactions) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "posttransactions",
    { ...transactions },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const fetchDisbursementReport = (
  fromDate,
  toDate,
  clientId,
  searchPhoneNumber,
  projectId
) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.get(
    API_URL +
      `disbursementreport/${fromDate}/${toDate}/${clientId}/${searchPhoneNumber}/${projectId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const fetchProjects = (clientId) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.get(API_URL + `fetchprojects/${clientId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const createProject = (project) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(API_URL + `createproject`, project, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const DataService = {
  getAllClients,
  getClient,
  getUsers,
  createClient,
  updateFloat,
  linkUser,
  processTransactions,
  fetchDisbursementReport,
  delinkUser,
  retryTransactions,
  fetchProjects,
  createProject,
};

export default DataService;
